import Vue from 'vue';

Vue.component('cdb-summary-cards', () =>
    import(/* webpackChunkName: 'cdb-summary-cards' */ './cdb-summary-cards.vue'),
);

Vue.component('cdb-reimbursement-chart', () =>
    import(/* webpackChunkName: 'cdb-reimbursement-chart' */ './cdb-reimbursement-chart.vue'),
);

Vue.component('vuetable-cdb-reimbursement', () =>
    import(/* webpackChunkName: 'cdb-reimbursement-table' */ './vuetable-cdb-reimbursement.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/cdb-reimbursement/index.js